import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/AuthContext';
import { StorageHelper } from '../utils/StorageHelper';
import { HostProvider } from '../utils/HostProvider';

const BotonVolverFlotante: FC = () => {
  const { t } = useTranslation();
  const dataUser = useAuthStore();
  const fromApp = StorageHelper.getFromApp() as string;
  const isApp = dataUser.user.isApp === 'true';
  const fromUrl = StorageHelper.getFromUrl() as string;
  const isEroski = HostProvider.isEroski();
  const location = useLocation();
  const urlActual = location.pathname;

  const textoBotonFlotante = () => {
    let text = '';
    if (fromApp === 'web_ecommerce') {
      text = isEroski
        ? `${t('botonFlotante.volver.superOnline')}`
        : `${t('caprabo.botonFlotante.volver.superOnline')}`;
    } else if (fromApp === 'web_familia_ecommerce') {
      text = `${t('botonFlotante.volver.familia')}`;
    }
    return text;
  };
  const getHref = (url: string) => {
    const baseUrl = isEroski
      ? process.env.REACT_APP_API
      : process.env.REACT_APP_API_CAPRABO;

    return `${baseUrl}/clienteLogado/getTK?fromUrl=${url}&fromApp=${fromApp}`;
  };
  const clicBotonFlotante = () => {
    if (fromApp === 'web_ecommerce') {
      if (fromUrl === null || fromUrl === undefined || fromUrl === '') {
        window.location.href = isEroski
          ? getHref(`${process.env.REACT_APP_SERVER_SUPER}${t('link.super')}`)
          : getHref(`${process.env.REACT_APP_CAPRABO_CASA}`);
      } else {
        window.location.href = getHref(fromUrl);
      }
    } else if (fromApp === 'web_familia_ecommerce') {
      if (fromUrl === null || fromUrl === undefined || fromUrl === '') {
        window.location.href = getHref(
          `${process.env.REACT_APP_HOST_FAMILIA_ONLINE}`,
        );
      } else {
        window.location.href = getHref(fromUrl);
      }
    }
  };
  useEffect(() => {
    const pathTarjeta = urlActual.includes('/tarjeta');
    const botonFlotante = document.querySelector('.boton-sticky');
    if (pathTarjeta && botonFlotante) {
      botonFlotante.classList.add('tarjeta');
    } else if (botonFlotante) {
      botonFlotante.classList.remove('tarjeta');
    }
  }, [urlActual]);
  return (
    <>
      {!isApp &&
      (fromApp === 'web_ecommerce' || fromApp === 'web_familia_ecommerce') ? (
        <div className="boton-sticky">
          <button
            type="button"
            className="btn btn-fijo"
            onClick={clicBotonFlotante}
          >
            <div className="icon icon-medium">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                <polygon
                  fillRule="evenodd"
                  points="8.388 0 .667 8 8.388 16 9.084 15.278 2.525 8.482 16 8.482 16 7.461 2.58 7.461 9.084 .721"
                />
              </svg>
            </div>
            <p>{textoBotonFlotante()}</p>
          </button>
        </div>
      ) : (
        ''
      )}
    </>
  );
};

export default BotonVolverFlotante;
